import {
	ACCEPTED_TERMS as ACCEPT_TERMS,
	LOGIN_SSO_FACEBOOK_ERROR,
	LOGIN_SSO_FACEBOOK_REQUEST,
	LOGIN_SSO_FACEBOOK_SUCCESS,
	LOGIN_SSO_GOOGLE_ERROR,
	LOGIN_SSO_GOOGLE_REQUEST,
	LOGIN_SSO_GOOGLE_SUCCESS,
	LOGIN_SUCCESS,
	LOGOUT,
	REFRESH_TOKEN,
	REJECTED_TERMS as REJECT_TERMS
} from '../types/types';

export const LoginAuthAction = (response: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: LOGIN_SUCCESS,
			payload: response
		});
	};
};

export const RefreshTokenAction = (response: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: REFRESH_TOKEN,
			payload: response
		});
	};
};

export const LogoutAction = () => {
	return (dispatch: any) => {
		dispatch({ type: LOGOUT });
	};
};

export const AcceptTermsAction = () => {
	return (dispatch: any) => {
		dispatch({ type: ACCEPT_TERMS });
	};
};

export const RejectTermsAction = () => {
	return (dispatch: any) => {
		dispatch({ type: REJECT_TERMS });
	};
};

// action loginSSOGoogle request
export const loginSSOGoogleRequestAction = (user = {}) => {
	return (dispatch: any) => {
		dispatch({ type: LOGIN_SSO_GOOGLE_REQUEST, user: user });
	};
};

// action loginSSOGoogle success
export const loginSSOGoogleSuccessAction = (data: any) => {
	return (dispatch: any) => {
		dispatch({ type: LOGIN_SSO_GOOGLE_SUCCESS, payload: data });
	};
};

// action loginSSOGoogle failure
export const loginSSOGoogleFailureAction = (error: any) => {
	return (dispatch: any) => {
		dispatch({ type: LOGIN_SSO_GOOGLE_ERROR, error: error });
	};
};

// action loginSSOFacebook request
export const loginSSOFacebookRequestAction = (user = {}) => {
	return (dispatch: any) => {
		dispatch({ type: LOGIN_SSO_FACEBOOK_REQUEST, user: user });
	};
};

// action loginSSOFacebook success
export const loginSSOFacebookSuccessAction = (data: any) => {
	return (dispatch: any) => {
		dispatch({
			type: LOGIN_SSO_FACEBOOK_SUCCESS,
			payload: data
		});
	};
};

// action loginSSOFacebook failure
export const loginSSOFacebookFailureAction = (error: any) => {
	return (dispatch: any) => {
		dispatch({ type: LOGIN_SSO_FACEBOOK_ERROR, error: error });
	};
};
